import { useEffect } from 'react';
import { buildApiUrl } from '../config/api';

/**
 * Injecte Google Analytics (gtag) si un identifiant est configuré dans l'admin
 * (réglage googleAnalyticsId). Rien n'est chargé tant que l'identifiant n'est
 * pas renseigné : aucun traceur tiers par défaut.
 *
 * L'injection est faite au runtime depuis les réglages plutôt qu'en dur dans
 * index.html, pour que l'activation/désactivation se fasse depuis le panneau
 * d'administration sans redéploiement.
 */
export const useAnalytics = () => {
  useEffect(() => {
    let cancelled = false;

    fetch(buildApiUrl('/settings/public'))
      .then((r) => (r.ok ? r.json() : null))
      .then((data) => {
        if (cancelled || !data) return;
        const id: string | undefined = data.googleAnalyticsId?.value;
        if (!id || !id.trim() || document.getElementById('ga-script')) return;

        const loader = document.createElement('script');
        loader.id = 'ga-script';
        loader.async = true;
        loader.src = `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(id)}`;
        document.head.appendChild(loader);

        const init = document.createElement('script');
        init.textContent =
          `window.dataLayer = window.dataLayer || [];` +
          `function gtag(){dataLayer.push(arguments);}` +
          `gtag('js', new Date());` +
          `gtag('config', '${id.replace(/'/g, '')}');`;
        document.head.appendChild(init);
      })
      .catch(() => {
        // Pas de mesure d'audience si l'API ne répond pas : sans conséquence.
      });

    return () => {
      cancelled = true;
    };
  }, []);
};
